import React, { useState } from "react";
import styles from "./SummerPage.module.css";
import EnrollmentForm from "../enrollment/EnrollmentForm"; // Adjust path as needed

const SummerPage = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <div className={styles.flyerWrapper}>
      <div className={styles.landscapeFlyer}>
        {/* Left Section: Branding */}
        <div className={styles.brandingZone}>
          <div className={styles.sunBadge}>SUMMER 2026</div>
          <h1 className={styles.mainTitle}>
            SUMMER ART <br /> <span>CAMP</span>
          </h1>
          <p className={styles.tagline}>Let your imagination run wild!</p>
          <div className={styles.datesBox}>JULY 06 - JULY 31</div>
        </div>

        {/* Center Section: Activities */}
        <div className={styles.activityZone}>
          <div className={`${styles.card} ${styles.blue}`}>
            <span className={styles.emoji}>🎨</span>
            <h4>Acrylics</h4>
          </div>
          <div className={`${styles.card} ${styles.yellow}`}>
            <span className={styles.emoji}>🏺</span>
            <h4>Sculpture</h4>
          </div>
          <div className={`${styles.card} ${styles.green}`}>
            <span className={styles.emoji}>👕</span>
            <h4>Tie-Dye</h4>
          </div>
          <div className={`${styles.card} ${styles.coral}`}>
            <span className={styles.emoji}>🎨</span>
            <h4>Puppets</h4>
          </div>
          <div className={`${styles.card} ${styles.coral}`}>
            <span className={styles.emoji}>🎨</span>
            <h4>Madhubani Art</h4>
          </div>
          <div className={`${styles.card} ${styles.coral}`}>
            <span className={styles.emoji}>🎨</span>
            <h4><span>    Mandella Art</span></h4>
          </div>
          <div className={`${styles.card} ${styles.coral}`}>
            <span className={styles.emoji}>🎨</span>
            <h4>Glass painting</h4>
          </div>
          <div className={`${styles.card} ${styles.coral}`}>
            <span className={styles.emoji}>🎨</span>
            <h4>Portrait drawing</h4>
          </div>
        </div>

        {/* Right Section: Action */}
        <div className={styles.actionZone}>
          <div className={styles.priceCircle}>
            <span>Starting at</span>
            <h2>$150</h2>
            <span>/week</span>
          </div>
          <button
            className={styles.enrollBtn}
            onClick={() => setModalOpen(true)}
          >
            REGISTER NOW!
          </button>
          <p className={styles.ageLimit}>Limited Spots • Ages 6-12</p>
        </div>
      </div>

      {/* Global Enrollment Form */}
      <EnrollmentForm
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        selectedProgram="Summer Art Camp 2026"
      />
    </div>
  );
};

export default SummerPage;
